import { render, staticRenderFns } from "./Remote.vue?vue&type=template&id=69c3a4db&scoped=true&"
import script from "./Remote.vue?vue&type=script&lang=js&"
export * from "./Remote.vue?vue&type=script&lang=js&"
import style0 from "./Remote.vue?vue&type=style&index=0&id=69c3a4db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c3a4db",
  null
  
)

component.options.__file = "Remote.vue"
export default component.exports